import Pagenotfound from "Pages/404page";
import React from "react";
import { useSelector } from "react-redux";
import { PendingPermissionKeys } from "utilities/permissionConst";

const RouteProtector = ({ children, permissionKey }) => {
  const permission = useSelector((s) => s?.profileData);
  const role = useSelector((s) => s?.login?.role);

  if (role == "1") {
    // super admin
    return children;
  }

  if (PendingPermissionKeys.includes(permissionKey)) {
    if (!permission.pendingRequestSubViewNames.includes(permissionKey)) {
      return <Pagenotfound notPermitted={true} />;
    }
  } else if (
    !permission[permissionKey]?.isView &&
    !PendingPermissionKeys.includes(permissionKey)
  ) {
    return <Pagenotfound notPermitted={true} />;
  }

  return children;
};

export default RouteProtector;
